import {RadioButton} from "../../../../lib/prm/radio-button";
import {Name} from "../../../../lib/prm/name";

const UGMA_INVITE_PAYMENT_TYPE = new RadioButton(
  new Name("UGMA_INVITE_PAYMENT_TYPE"),
  [
    new Name("ach", "Make an Electronic ACH Payment"),
    new Name("check", "Mail a check"),
  ]);

export { UGMA_INVITE_PAYMENT_TYPE };
